(() => {
  'use strict';

  const setupBundlePicker = (picker) => {
    if (picker.dataset.psnReady === 'true') return;
    picker.dataset.psnReady = 'true';

    const radios = Array.from(picker.querySelectorAll('input[name="quantity"]'));
    if (radios.length === 0) return;

    const productSection = picker.closest('.section-product-info') || picker.closest('section');
    const formId = picker.dataset.formId || '';
    const sectionId = picker.dataset.sectionId || formId.replace(/^product-form-/, '');
    const mainForm = formId ? document.getElementById(formId) : null;
    const stickyForm = sectionId ? document.getElementById(`product-form-sticky-${sectionId}`) : null;

    // Colour rows live inside the option cards. "1st/main" swatches drive the theme's own
    // (visually hidden) colour radios so Eurus keeps variant, price, media and sticky bar in sync.
    // "2nd colour" swatches add the second variant as an extra cart line for the 2-pack.
    const colorButtons = Array.from(picker.querySelectorAll('[data-psn-color-option]'));
    const colorNames = Array.from(picker.querySelectorAll('[data-psn-color-name]'));
    const colorRows = Array.from(picker.querySelectorAll('[data-psn-colors]'));
    const second = picker.querySelector('[data-psn-second]');
    const secondButtons = second ? Array.from(second.querySelectorAll('[data-psn-second-option]')) : [];
    const secondName = second ? second.querySelector('[data-psn-second-name]') : null;
    let secondChoice = '';

    const packOf = (radio) => radio.dataset.pack || radio.value;

    const mainVariantId = () => {
      const input = mainForm ? mainForm.querySelector('input[name="id"]') : null;
      return input ? String(input.value) : '';
    };

    const nativeColorRadio = (color) => {
      const scope = (sectionId && document.getElementById(`variant-update-${sectionId}`)) || productSection || document;
      return Array.from(scope.querySelectorAll('input[type="radio"][name^="Color"]')).find((radio) => radio.value === color) || null;
    };

    const colorNameFor = (variantId) => {
      const button = colorButtons.find((candidate) => candidate.dataset.variantId === variantId);
      return button ? button.dataset.color || '' : '';
    };

    const syncFormQuantity = (form, quantity, pack) => {
      if (!form) return;
      const quantityControls = Array.from(form.elements).filter((control) => control.name === 'quantity');
      quantityControls.forEach((control) => {
        if (control.type === 'radio') {
          control.checked = packOf(control) === pack;
        } else {
          control.value = quantity;
          control.setAttribute('value', quantity);
        }
      });
    };

    const setExtraItem = (form, variantId) => {
      if (!form) return;
      let idInput = form.querySelector('input[data-psn-extra="id"]');
      let qtyInput = form.querySelector('input[data-psn-extra="quantity"]');
      if (!variantId) {
        if (idInput) idInput.remove();
        if (qtyInput) qtyInput.remove();
        return;
      }
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'items[0][id]';
        idInput.dataset.psnExtra = 'id';
        form.appendChild(idInput);
      }
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'items[0][quantity]';
        qtyInput.value = '1';
        qtyInput.dataset.psnExtra = 'quantity';
        form.appendChild(qtyInput);
      }
      idInput.value = variantId;
    };

    const syncPrice = (displayTotal) => {
      if (!displayTotal || !sectionId) return;
      const escapedSectionId = CSS.escape(sectionId);
      document.querySelectorAll(
        `#x-atc-button-${escapedSectionId} .main-product-price > p.price, ` +
        `#x-atc-button-${escapedSectionId} .main-product-price > .price-sale, ` +
        `.price-sticky-${escapedSectionId} > .price > p.price, ` +
        `.price-sticky-${escapedSectionId} > .price > .price-sale, ` +
        `[data-psn-sticky-display-total]`
      ).forEach((price) => {
        price.textContent = displayTotal;
      });
    };

    // Sticky bar: one plain summary ("2 PeeSports · $99.95 / Black + Blue · Change") instead of the
    // theme's expand arrow. Tapping it scrolls back to the cards.
    const sticky = sectionId ? document.getElementById(`sticky-add-to-cart-${sectionId}`) : null;
    let summary = null;
    const ensureSummary = () => {
      if (summary || !sticky) return;
      const bar = sticky.querySelector('.x-pgw') || sticky.firstElementChild;
      const cartBlock = bar ? bar.querySelector('[x-data^="xProductCart"]') : null;
      if (!bar || !cartBlock) return;
      summary = document.createElement('button');
      summary.type = 'button';
      summary.className = 'ps-sticky-sum';
      summary.setAttribute('aria-label', 'Change your selection');
      summary.innerHTML = '<span class="ps-sticky-sum__t" data-psn-sum-title></span><span class="ps-sticky-sum__p"><span data-psn-sum-colors></span><u>Change</u></span>';
      summary.addEventListener('click', () => {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      bar.insertBefore(summary, cartBlock);
    };

    const renderSummary = (pack, mainName, secondColorName, displayTotal, label) => {
      ensureSummary();
      if (!summary) return;
      let title = label || (pack === '2' ? '2 PeeSports' : '1 PeeSport');
      if (displayTotal) title += ' · ' + displayTotal;
      let colors = mainName || '';
      if (pack === '2' && secondColorName && secondColorName !== mainName) colors += ' + ' + secondColorName;
      const titleEl = summary.querySelector('[data-psn-sum-title]');
      const colorsEl = summary.querySelector('[data-psn-sum-colors]');
      if (titleEl && titleEl.textContent !== title) titleEl.textContent = title;
      if (colorsEl && colorsEl.textContent !== colors) colorsEl.textContent = colors;
    };

    const render = () => {
      const selected = radios.find((radio) => radio.checked) || radios[0];
      const pack = packOf(selected) === '2' ? '2' : '1';
      const main = mainVariantId();
      const mainName = colorNameFor(main);
      let extra = '';
      let secondColorName = '';

      colorButtons.forEach((button) => {
        button.setAttribute('aria-checked', String(button.dataset.variantId === main));
      });
      colorNames.forEach((name) => {
        if (mainName && name.textContent !== mainName) name.textContent = mainName;
      });
      colorRows.forEach((row) => {
        row.hidden = row.dataset.psnColors !== pack;
      });

      if (second && pack === '2') {
        const explicit = secondButtons.find((button) => button.dataset.variantId === secondChoice && !button.disabled);
        const chosen = explicit ? explicit.dataset.variantId : main;
        secondButtons.forEach((button) => {
          button.setAttribute('aria-checked', String(button.dataset.variantId === chosen));
        });
        const chosenButton = secondButtons.find((button) => button.dataset.variantId === chosen);
        secondColorName = chosenButton ? chosenButton.dataset.color || '' : '';
        if (secondName && secondColorName && secondName.textContent !== secondColorName) secondName.textContent = secondColorName;
        if (chosen && main && chosen !== main) extra = chosen;
      }

      // Two different colors → quantity 1 of the selected color + 1 of the second color.
      const quantity = extra ? '1' : pack;
      radios.forEach((radio) => {
        if (packOf(radio) === '2') radio.value = quantity === '1' && extra ? '1' : '2';
      });

      syncFormQuantity(mainForm, quantity, pack);
      syncFormQuantity(stickyForm, quantity, pack);
      setExtraItem(mainForm, extra);
      setExtraItem(stickyForm, extra);
      syncPrice(selected.dataset.displayTotal);
      renderSummary(pack, mainName, secondColorName, selected.dataset.displayTotal, selected.dataset.summaryLabel);

      picker.querySelectorAll('.psn-bundle__option').forEach((option) => {
        const input = option.querySelector('input[name="quantity"]');
        option.classList.toggle('is-active', Boolean(input?.checked));
      });
    };

    colorButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (button.disabled) return;
        const native = nativeColorRadio(button.dataset.color || '');
        if (native && !native.checked) {
          native.click();
        }
        // Optimistic highlight; the theme's variant event re-renders once the form id updates.
        colorButtons.forEach((candidate) => {
          candidate.setAttribute('aria-checked', String(candidate === button || candidate.dataset.variantId === button.dataset.variantId));
        });
        requestAnimationFrame(render);
      });
    });

    secondButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (button.disabled) return;
        secondChoice = button.dataset.variantId || '';
        render();
      });
    });

    // Tapping anywhere on a card (outside its swatches) selects that pack.
    picker.querySelectorAll('.psn-bundle__option').forEach((option) => {
      option.addEventListener('click', (event) => {
        if (event.target instanceof Element && (event.target.closest('button') || event.target.closest('label'))) return;
        const input = option.querySelector('input[name="quantity"]');
        if (input && !input.checked) {
          input.checked = true;
          render();
        }
      });
    });

    picker.addEventListener('change', render);
    productSection?.addEventListener('submit', render, true);
    if (mainForm) {
      mainForm.addEventListener('change', (event) => {
        if (event.target && event.target.name === 'id') requestAnimationFrame(render);
      });
    }
    if (sectionId) {
      document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, () => {
        requestAnimationFrame(render);
      });
    }
    document.addEventListener('eurus:product:added', () => requestAnimationFrame(render));
    if (sticky && 'MutationObserver' in window) {
      // The theme re-renders parts of the sticky bar; make sure our summary survives.
      new MutationObserver(() => {
        if (summary && !summary.isConnected) {
          summary = null;
          render();
        }
      }).observe(sticky, { childList: true, subtree: true });
    }
    render();
  };

  const setupVideoGallery = (gallery) => {
    if (gallery.dataset.psnReady === 'true') return;
    gallery.dataset.psnReady = 'true';

    const video = gallery.querySelector('[data-psn-video]');
    const playButton = gallery.querySelector('[data-psn-video-play]');
    const options = Array.from(gallery.querySelectorAll('[data-psn-video-option]'));
    if (!video || !playButton || options.length === 0) return;

    let activeOption = options.find((option) => option.getAttribute('aria-pressed') === 'true') || options[0];

    const selectVideo = (option) => {
      if (!option || option === activeOption) return;
      video.pause();
      activeOption = option;
      video.src = option.dataset.videoSrc || '';
      video.poster = option.dataset.videoPoster || '';
      video.setAttribute('aria-label', option.dataset.videoLabel || 'PeeSport video');
      video.load();
      playButton.hidden = false;
      playButton.setAttribute('aria-label', `Play ${(option.dataset.videoLabel || 'PeeSport video').toLowerCase()}`);
      options.forEach((candidate) => {
        candidate.setAttribute('aria-pressed', String(candidate === option));
      });
    };

    options.forEach((option) => {
      option.addEventListener('click', () => selectVideo(option));
    });

    playButton.addEventListener('click', async () => {
      try {
        await video.play();
      } catch (error) {
        playButton.hidden = false;
      }
    });

    video.addEventListener('play', () => {
      playButton.hidden = true;
    });
    video.addEventListener('pause', () => {
      if (video.currentTime === 0 || video.ended) playButton.hidden = false;
    });
    video.addEventListener('ended', () => {
      playButton.hidden = false;
    });
  };

  const setupStickyVisibility = (productSection) => {
    if (!productSection || productSection.dataset.psnStickyReady === 'true') return;

    const mainButton = productSection.querySelector('.x-block-buy-buttons .add_to_cart_button');
    const sticky = productSection.querySelector('[data-psn-sticky-managed]');
    if (!mainButton || !sticky) return;
    productSection.dataset.psnStickyReady = 'true';

    const viewport = window.visualViewport;
    let frame = 0;
    let visible = false;

    const setVisible = (nextVisible) => {
      if (visible === nextVisible && sticky.hidden === !nextVisible) return;
      visible = nextVisible;
      sticky.hidden = !nextVisible;
      sticky.setAttribute('aria-hidden', String(!nextVisible));
    };

    const update = () => {
      frame = 0;
      const viewportTop = viewport?.offsetTop || 0;
      const viewportHeight = viewport?.height || window.innerHeight;
      const viewportBottom = viewportTop + viewportHeight;
      const buttonRect = mainButton.getBoundingClientRect();
      if (buttonRect.width === 0 || buttonRect.height === 0) {
        setVisible(false);
        return;
      }
      const footerRect = document.getElementById('section-footer')?.getBoundingClientRect();
      const footerReached = Boolean(footerRect && footerRect.top < viewportBottom - 8);
      const comfortablyVisible = buttonRect.top >= viewportTop + 10 && buttonRect.bottom <= viewportBottom - 10;
      const clipped = buttonRect.top < viewportTop + 2 || buttonRect.bottom > viewportBottom - 2;

      if (footerReached) {
        setVisible(false);
      } else if (visible) {
        setVisible(!comfortablyVisible);
      } else {
        setVisible(clipped);
      }
    };

    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    viewport?.addEventListener('scroll', schedule, { passive: true });
    viewport?.addEventListener('resize', schedule, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(mainButton);
    }

    schedule();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('ps-bundle-picker').forEach(setupBundlePicker);
    root.querySelectorAll('ps-video-gallery').forEach(setupVideoGallery);
    root.querySelectorAll('.section-product-info').forEach((productSection) => {
      setupStickyVisibility(productSection);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

})();
